module.exports = __webpack_public_path__ + "static/media/SortedNewUp.f1945b74.svg";